import React, { useEffect, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { kenticoApi } from "apiConsumers";
import ZigZagPatternBackground from "components/backgrounds/ZigZagPatternBackground";
import PageSection from "components/layout/PageSection";
import { featureTileYellow, layoutConsts, zigzagBackgroundBlack } from "theme";
import IQuote from "apiConsumers/kenticoApiConsumer/models/quotes/IQuote";
import Quote from "./Quote";
import SelectableCollection from "components/selectableCollection/SelectableCollection";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            color: theme.palette.common.black,
            backgroundColor: zigzagBackgroundBlack,
            position: "relative",
        },
        contentContainer: {
            flex: "1",
            color: featureTileYellow,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            zIndex: 1,
        },
    })
);

export default function QuotesSection() {
    const classes = useStyles();

    const [quotes, setQuotes] = useState<IQuote[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        kenticoApi
            .getQuotes()
            .then((response) => {
                if (typeof response === "undefined") return;

                setQuotes(response);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return isLoading || quotes.length === 0 ? null : (
        <PageSection
            skewed
            topSeparatorVariant="secondary"
            classes={{ skewedSectionRoot: classes.root }}
            maxWidth="unset"
        >
            <ZigZagPatternBackground />
            <div className={classes.contentContainer}>
                <SelectableCollection
                    style={{ maxWidth: layoutConsts.siteContentMaxWidth }}
                    items={quotes}
                    renderItem={(quote: IQuote) => (
                        <div
                            style={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Quote quote={quote} />
                        </div>
                    )}
                    autoTransitionDuration={5000}
                    disableArrows
                />
            </div>
        </PageSection>
    );
}
